import {colord} from 'colord'

const REG_HEX_COLOR = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i

export function upgrade(userSettings) {
  const {favorites} = userSettings
  favorites.colors = favorites.colors ?
    favorites.colors.reduce(
      (accumulator, currentValue) => {
        const colordValue = colord(currentValue.color)
        if (colordValue.isValid()){
          const color = colordValue.toHex()
          if (REG_HEX_COLOR.test(color)) {
            accumulator.push({...currentValue, color})
          }
        }
        return accumulator
      },
      []
    ) :
    []
}

export const DEFAULT_SETTINGS = {
  trialActivatedMessageSeen: false,
  isLiked: false,
  isQuickMenuShown: false,
  tips: {
    version: 0
  },
  favorites: {
    fonts: [],
    colors: []
  },
  preferences: {
    autoConfirmSwapVideo: false
  },
  newFeatures: {
    'character-builder': {
      dismissedTimestamp: undefined,
      viewState: 'new'
    }
  },
  notifications: {
    revisionMode: {}
  }
}
  